import httpInstances from '@/api/axiosInstance';

export type ApiKeyOutput = {
  prefixedRawApiKey?: string;
  id: number;
  lastThreeCharacters: string;
  label: string;
  creationDate: string;
  lastUsed?: string;
};

export const apiKeysApi = {
  fetchAll: async (): Promise<ApiKeyOutput[]> => {
    const { data } = await httpInstances.axiosInternalInstance.get('proxy/auth/apikey');
    return data.apiKeyOutputs;
  },

  create: async (label: string): Promise<ApiKeyOutput> => {
    const { data } = await httpInstances.axiosInternalInstance.post(
      'proxy/auth/apikey',
      { label },
      { headers: { Accept: 'application/json' } }
    );
    return data;
  },

  delete: async (id: number): Promise<void> => {
    await httpInstances.axiosInternalInstance.delete(`proxy/auth/apikey/${id}`, {
      headers: { Accept: 'application/json' }
    });
  }
};
